/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterDimensions_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_itemSearch">;
    readonly " $refType": "SbMobileRefineMenuFilterDimensions_itemSearch";
};
export type SbMobileRefineMenuFilterDimensions_itemSearch$data = SbMobileRefineMenuFilterDimensions_itemSearch;
export type SbMobileRefineMenuFilterDimensions_itemSearch$key = {
    readonly " $data"?: SbMobileRefineMenuFilterDimensions_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterDimensions_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileRefineMenuFilterDimensions_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '20d72508705c8fed823eb4b49ff95603';
export default node;
